
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleLongSummary"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numActiveUsers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numDeclinedUsers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numInactiveUsers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numInvitedUsers"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":144}};
    doc.loc.source = {"body":"fragment RoleFragment on RoleLongSummary {\n   id\n   name\n   type\n   numActiveUsers\n   numDeclinedUsers\n   numInactiveUsers\n   numInvitedUsers\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
